import { useState } from "react";
import useClickedOutside from "../../hooks/useClickedOutside";
import { usePopper } from "react-popper";
import IconButton from "../IconButton";
import { MenuWrapper } from "./styles";
import { createPortal } from "react-dom";

const HamburgerMenu = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const menuRef = useClickedOutside(() => {
    setShowMenu(false);
  });

  const { styles, attributes } = usePopper(anchorElement, popperElement, {
    placement: "bottom-end",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 10],
        },
      },
    ],
  });

  return (
    <>
      <div ref={setAnchorElement}>
        <IconButton
          src="/assets/bars-menu.svg"
          onClick={() => setShowMenu(true)}
        />
      </div>

      {showMenu &&
        createPortal(
          <MenuWrapper
            ref={(node) => {
              setPopperElement(node);
              menuRef.current = node;
            }}
            style={styles.popper}
            {...attributes.popper}
          >
            {children}
          </MenuWrapper>,
          document.body
        )}
    </>
  );
};

export default HamburgerMenu;
